// src/pages/NewLogistPage/index.jsx

import React, { useEffect, useState } from 'react';
import styles from './NewLogistPage.module.css';
import api from '../../../services/api';
import MapComponent from '../LogisistMainPage/components/LogistMapComponent';  // твой готовый компонент карты

export default function NewLogistPage() {
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [unassigned, setUnassigned] = useState([]);

  // Диапазон дат
  const todayISO = new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(todayISO);
  const [endDate, setEndDate]   = useState(todayISO);

  // Загрузка маршрутных листов
  useEffect(() => {
    ;(async () => {
      try {
        const data = await api.get('/routes/by-date', {
          params: { startDate, endDate }
        });
        const arr = Array.isArray(data) ? data : [];
        setRoutes(arr);
        if (!arr.find(r => r.id === selectedRoute?.id)) {
          setSelectedRoute(arr[0] || null);
        }
      } catch (e) {
        console.error('Ошибка загрузки маршрутов:', e);
      }
    })();
  }, [startDate, endDate]);

  // Загрузка нераспределённых квитанций
  useEffect(() => {
    ;(async () => {
      try {
        const data = await api.get('/receipts', {
          params: { startDate, endDate, available: true }
        });
        setUnassigned(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('Ошибка загрузки незанятых квитанций:', e);
      }
    })();
  }, [startDate, endDate]);

  return (
    <div className={styles.app}>
      <header className={styles.header}>
        <span>Планирование</span>
        <div className={styles.dateFilter}>
          <label>
            С:&nbsp;
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
            />
          </label>
          <label>
            По:&nbsp;
            <input
              type="date"
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
            />
          </label>
        </div>
      </header>

      <div className={styles.main}>
        {/* ЛЕВАЯ КОЛОНКА: маршруты */}
        <aside className={styles.sidebar}>
          <h3>Маршрутные листы</h3>
          <ul className={styles.routesList}>
            {routes.length > 0 ? (
              routes.map(r => (
                <li
                  key={r.id}
                  className={
                    r.id === selectedRoute?.id
                      ? `${styles.routeItem} ${styles.selectedRoute}`
                      : styles.routeItem
                  }
                  onClick={() => setSelectedRoute(r)}
                >
                  №{r.route_number} ({r.route_date})
                </li>
              ))
            ) : (
              <li className={styles.empty}>Нет маршрутов</li>
            )}
          </ul>
        </aside>

        {/* ЦЕНТР: карта */}
        <section className={styles.mapSection}>
          {selectedRoute ? (
            <MapComponent
              receipts={selectedRoute.receipts}
              className={styles.map}
            />
          ) : (
            <div className={styles.mapPlaceholder}>Выберите маршрут</div>
          )}
        </section>

        {/* ПРАВАЯ КОЛОНКА: квитанции */}
        <aside className={styles.sidebar}>
          <h3>
            {selectedRoute
              ? `Заказы маршрута №${selectedRoute.route_number}`
              : 'Нераспределённые заказы'}
          </h3>
          <div className={styles.receiptsList}>
            {(selectedRoute ? selectedRoute.receipts : unassigned).length > 0 ? (
              (selectedRoute ? selectedRoute.receipts : unassigned).map(rec => (
                <div
                  key={rec.id}
                  className={styles.receiptCard}
                  onClick={() => {
                    // TODO: назначить rec на selectedRoute или открыть карточку
                  }}
                >
                  <div className={styles.rcHeader}>
                    <span className={styles.rcNumber}>№{rec.receipt_number}</span>
                    <span
                      className={`${styles.rcStatus} ${
                        styles[`status_${rec.status.replace(/\s+/g, '')}`]
                      }`}
                    >
                      {rec.status}
                    </span>
                  </div>
                  <div className={styles.rcBody}>
                    <div className={styles.rcField}>
                      <strong>Адрес:</strong> {rec.delivery_address}
                    </div>
                    <div className={styles.rcField}>
                      <strong>Клиент:</strong> {rec.client_name}
                    </div>
                    <div className={styles.rcField}>
                      <strong>Окно:</strong> {rec.delivery_time || '—'}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.empty}>Нет квитанций</div>
            )}
          </div>
        </aside>
      </div>
    </div>
  );
}
